import { MappedStoryType } from "../../../models/modelTypes";
import { getData } from "../rest";
import { objectToQueryString } from "../../../utils/api";
import { StoryFetchParameters } from "../../../../../common/build/api-parameters/story";

export const getMappedStory = async (mappedStoryId: number, args?: StoryFetchParameters): Promise<MappedStoryType> =>
    await getData(`/public/story/${mappedStoryId}${objectToQueryString(args ?? {})}`);
